class MMProductDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length || this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    const section = this.closest('.shopify-section');
    if (section) {
      section.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest('[data-mm-tab-index]');
        if (!block) return;
        const tab = this.querySelector(`[role="tab"][data-mm-tab-index="${block.dataset.mmTabIndex}"]`);
        if (tab) this.activate(tab);
      });
    }
  }

  activate(activeTab, focus = false) {
    this.tabs.forEach((tab) => {
      const selected = tab === activeTab;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
    });

    if (focus) activeTab.focus();
  }

  onKeydown(event, index) {
    let next = index;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;

    event.preventDefault();
    this.activate(this.tabs[next], true);
  }
}

if (!customElements.get('mm-product-details-tabs')) {
  customElements.define('mm-product-details-tabs', MMProductDetailsTabs);
}
